<template>
  <div class="page__wrapper"></div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-placeholder2.jpg");
  background-size: cover;
  background-position: center;
}
</style>